import { useAppDispatch } from "./reduxHooks";
import { setToast } from "../redux/actions/configActions";

export type toastPayload = {
  title?: string;
  body?: string;
  type?: string;
};

function useToast() {
  const dispatch = useAppDispatch();
  function alert(toastData: toastPayload, delay = 5000) {
    dispatch(setToast({ ...toastData, visible: true }));
    setTimeout(() => dispatch(setToast({ visible: false })), delay);
  }
  return {
    alert,
  };
}

export default useToast;
